var _g, _path, _path2, _tspan, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.75,
    height: 22.1,
    viewBox: "0 0 20.75 22.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "picture-file") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "picture-file"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,22.1c-3.7,0-5.8-2.1-5.8-5.8V6.3C2.2,2.6,4.3.5,8,.5h8c3.7,0,5.8,2.1,5.8,5.8v10c0,3.6-2.1,5.8-5.8,5.8ZM3.7,6.3v10c0,2.9,1.4,4.2,4.2,4.2h8c2.9,0,4.3-1.4,4.3-4.2V6.3c0-2.9-1.4-4.2-4.3-4.2H8C5.1,2.1,3.7,3.5,3.7,6.3Z",
    transform: "translate(-1.3 -0.25)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,8.6a2.8,2.8,0,0,1-2.8-2.8v-2a.79.79,0,0,1,.8-.8.74.74,0,0,1,.8.8v2A1.24,1.24,0,0,0,16.6,7h2a.79.79,0,0,1,.8.8.74.74,0,0,1-.8.8Z",
    transform: "translate(-1.3 -0.25)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,8.7",
    transform: "translate(-1.3 -0.25)",
    fill: "{props.color}",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7,13.7H2a.68.68,0,0,1-.7-.7V8.2A.68.68,0,0,1,2,7.5h8.7a.68.68,0,0,1,.7.7V13A.68.68,0,0,1,10.7,13.7Z",
    transform: "translate(-1.3 -0.25)",
    fill: "{props.color}",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.44 11.4) rotate(-0.34)",
    fontSize: 4.7,
    fill: "#fff",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, " jpg")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.3 -0.25)",
    fill: "#292d32",
    stroke: "#292d32",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.3 -0.25)",
    fill: "none",
    stroke: "#292d32",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.ddd08aaa26c2ec8dbdcc12ae3c882e28.svg";
export { ForwardRef as ReactComponent };